// Misc Untilities and functions
let jp = require("jsonpath");
window.jp = jp; // See jsonpath docs for filter params @ https://github.com/json-path/JsonPath

const TranslateJSON = function(data, idWndw) {
  window.tempIdWndw = idWndw
  data = translate(data, "$..visible_calc", mapVisible, "calcFunction"); // mapVisible returns a function

  //onPlaceChanged - Google Address
  data = translate(data, "$.pages..onPlaceChanged", onPlaceChanged, "function");

  //onComplete - Form Submit Button
  data = translate(data, "$.pages..onComplete", onComplete, "function");

  // regex to match all _calc's
  var thestring = JSON.stringify(data);

  // Getters;
  // var calcKeys = _.uniq(thestring.match(/(?!")\w+?_calc(?=")/g)) || [];
  var calcKeys = _.uniq(thestring.match(/(?!")[a-zA-Z0-9_ ]+?_calc(?=")/g)) || [];

  calcKeys.forEach(function(key) {
    try {
      if (key != "visible_calc" && key != "validator_calc") {
        // if ( key != "validator_calc") {
        data = translate(data, "$..['" + key + "']", makeCalcFunction, "getter");
      } 
    }
    catch(e) {
      BF.errorThrow(10200, `bfUtilities key: ${key}\nError: ${e}`, 'Error when evaluating calculation field.');
    }
  }, this);

  // Forced calcFunctions - calcf
  calcKeys = _.uniq(thestring.match(/(?!")\w+?_calcf(?=")/g)) || [];
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeCalcFunction, "calcFunction");
  }, this);

  // Functions - _function
  calcKeys = _.uniq(thestring.match(/(?!")\w+?_function(?=")/g)) || [];
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeFunction, "bfFunction");
  }, this);

  // Forced Getters - calcg
  calcKeys = _.uniq(thestring.match(/(?!")\w+?_calcg(?=")/g)) || [];
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeCalcFunction, "getter");
  }, this);

  //_actions;
  calcKeys = _.uniq(thestring.match(/(?!")\w+?_actions(?=")/g)) || [];
  calcKeys.forEach(function(key) {
    data = translate(data, "$.." + key, makeActionsFunct, "hardFunctionAtKey");
  }, this);

  return data;
};

// Handles  translation
const translate = function(data, filter, hardFunc, meth, key) {
  let paths = getPaths(data, filter);
  var theFunction

  for (var i = 0; i < paths.length; i++) {
    var path = paths[i];
    let regex = /\.([a-z0-9A-Z]+\/[a-z0-9A-Z]+)\./g; //regex to add square brackets around paths with '/'
    path = path.replace(regex, (match, p1) => {return `["${p1}"].`});
    if (
      _.get(data, "model.disableModelCalcs") &&
      path.startsWith("data.model.")
    ) {
      continue;
    }
 
    // SAMPLE: data.pages[0].schema.fields[0].actions_onRowClick[0].options.path_calc
    let funcText = _.get(data, path.substr(5) )

    if (meth == "function") {
      // Just replace the path with the function
      eval(path + " = hardFunc"); // needed?
      let objectPath = path.match(/.*(?=\..*)/)[0];
      _.set(data, objectPath + "." + key, hardFunc)
      continue;
    }

    key = path.match(/([a-zA-Z0-9_ ]+)(?=\_[a-z]+$)/)[0]; 
    let objectPath = path.match(/(?:^data\.)(.*)(?=\..*_)/)[1]; // parent path to the key, whithout 'data.''

    if (meth == "bfFunction") {
      // Try to make a function
       theFunction = makeFunction(funcText);
      _.set(data, objectPath + "." + key, theFunction)
      continue;
    }

    if (meth == "hardFunctionAtKey") {
      // puts function in where @ key without _xxxc()
      _.set(data, objectPath + "." + key, hardFunc(funcText))
      continue;
    }
 
    theFunction = makeCalcFunction(funcText, window.tempIdWndw );
    if (meth == "calcFunction") {
      _.set(data, `${objectPath}.${key}`, theFunction)
    } else if (meth == "getter") {
      // sticks the function in as a getter
      let object = _.get(data, objectPath);
      object[key + "_fcn"] = theFunction; // since 'this' sees the object, we will stick the _fcn in here
      object["_this"] = Function(`return this`);

      // map in data so we can ref in calcs, use as function so we don't get circ dep issues
      object["sourceData"] = function() {
        return data;
      };

      Object.defineProperty(object, key, {
        enumerable: true,
        configurable: true,
        // This getter will reference the actual function outside of the defineProperty scope
        // This is needed because the 'this' is the wrong scope inside the getter
        get() {
          return this[key + "_fcn"]();
        }
      });
      _.set(data, objectPath, object) // stick the object back in with its getter
    }
  }

  return data;
};

// Returns the list of matching paths
const getPaths = function(data, filter) {
  var paths = jp.paths(data, filter);
  var arrayLength = paths.length;
  var lineResult = [];
  for (var i = 0; i < arrayLength; i++) {
    var line = paths[i];
    for (var j = 0; j < line.length; j++) {
      var term = line[j];
      if (term == "$") {
      } else if (typeof term === "number") {
        lineResult[i] = lineResult[i] + "[" + term + "]";
      } else {
        lineResult[i] =
          lineResult[i] == null ? "data." + term : lineResult[i] + "." + term;
      }
    }
  }
  return lineResult;
};

/************************************ ***
 * Translation Funcions
 *
 *
 **************************************/

// GOOGLE ONPLACECHANGED Function called by google address fieldType
const onPlaceChanged = function(value, placeShort, place, model, schema) {
  model[schema.model + "_google"] = { placeShort, place };
  // model.googleAddress = { placeShort, place };
  return;
};

// BUTTON ONCOMPLETE Function called by submit button element
const onComplete = function(model, schema) {
  // TODO this should change to be an emit
  this.$parent.onComplete();
  return;
};

// VISIBLE_CALC Function swapper
// This returns a function with the value, (expression) hard coded
const mapVisible = function(data, path) {
  return data;
};

// *_CALC Function swapper
// This returns a function with the value, (expression) hard coded for the result
const makeCalcFunction = function(funcText, idWndw) {
  funcText ? 1 : (funcText = "'No Calc Defined!'"); // handles bad calcs
  try {
    return Function(`
      try {
          var app = _.get(window, 'vueapp.$store.state.site.content.app');
          var formSchema = vueapp.$store.getters.getFormSchema(${window.tempIdWndw}) ;
          var model = this.sourceData ? this.sourceData().model : _.get(formSchema, 'model');
          if (app && app.debugCalcs) debugger;
          var result =  ${funcText};
      }
      catch(err) {
          if (app && app.debugCalcs) console.log('error resolving *_calc: ', "${funcText}" , err.message );
          var result = false;
      }   
      return result;`); 
  }
  catch (error) {
    BF.errorThrow(10201, 'Failed to compile *_calc or *_calcf: ' + funcText, error);
  }
};

// ACTIONS_FUNCTION can be added anywhere an action is expected
/// returns a funtion that will queue the passed actions array
const makeActionsFunct = function(actions) {
  const actionsStr = JSON.stringify(actions);
  try {
    return Function(`
      let actions = ${actionsStr};
      let args = arguments;
        actions.forEach(function(action, index) {
            _.set(actions[index], 'options.args', args);
      });
      vueapp.$store.dispatch('ACTIONS_QUEUE', actions);
        return;`);
  }
  catch (err) {
    BF.errorThrow(10202, 'Failed to compile *_actions: ' + actions, err);
  }
};

// Conventional BFFUNCTION
const makeFunction = function(funcText) {
  funcText ? 1 : (funcText = "'No Calc Defined!'"); // handles bad calcs

      // console.log('@bfUtilities makeFunction funcText: ', funcText)
  // try to see if the function compiles
  try {
    return Function(`
    // *** make _function ***
        try {
            var app = _.get(window, 'vueapp.$store.state.site.content.app');
            var formSchema = this.sourceData ? this.sourceData() : _.get(window, 'formGen.formSchema');
            var model = this.sourceData ? this.sourceData().model : _.get(formSchema, 'model');
            if (app.debugFunctions) debugger;
            
            ${funcText};
        }
        catch(err) {
            if (app.debugCalcs) console.log('error resolving *_calc: ', "${funcText}" , err.message );
            var result = false;
            return result;
        }    `);
  }
  catch (err) {
    BF.errorThrow(10203, 'Failed to compile *_function: ' + funcText, err);
  }
};

// **********************************************************
// UUID Generator
const Uuid = function() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

window.uuid = Uuid;

// **********************************************************
// Get QueryParams
const getQueryParams = function() {
  var queryString = window.location.href
    .split("?")
    .slice(1)
    .join("?");
  var qparams = {},
    queries,
    temp,
    i,
    l;
  // Split into key/value pairs
  queries = queryString ? queryString.split("&") : [];
  // Convert the array of strings into an object
  for (i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split("=");
    qparams[temp[0]] = decodeURIComponent(temp[1]);
  }
  return qparams;
};


export { TranslateJSON, Uuid, getPaths, getQueryParams };